import { FC, SVGProps } from 'react';

export const SearchIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width='23' height='22' viewBox='0 0 23 22' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
		<g opacity='0.5' clipPath='url(#clip0_3085_11767)'>
			<path
				d='M10.421 4.5H10.412C9.70207 4.49921 8.99894 4.63826 8.34276 4.90921C7.68657 5.18016 7.09017 5.5777 6.58762 6.07914C6.08507 6.58058 5.68621 7.17609 5.4138 7.83167C5.1414 8.48726 5.00079 9.19008 5 9.9V9.91C5 12.892 7.423 15.31 10.412 15.31H10.421C11.1309 15.3108 11.8341 15.1717 12.4902 14.9008C13.1464 14.6298 13.7428 14.2323 14.2454 13.7309C14.7479 13.2294 15.1468 12.6339 15.4192 11.9783C15.6916 11.3227 15.8322 10.6199 15.833 9.91V9.9C15.833 6.918 13.41 4.5 10.421 4.5Z'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M17.4697 18.0301C17.539 18.1017 17.6217 18.1588 17.7133 18.198C17.8048 18.2373 17.9032 18.2579 18.0028 18.2587C18.1024 18.2596 18.2011 18.2405 18.2933 18.2028C18.3854 18.165 18.4691 18.1093 18.5395 18.0388C18.6099 17.9684 18.6656 17.8846 18.7032 17.7924C18.7409 17.7002 18.7598 17.6015 18.7589 17.5019C18.758 17.4023 18.7373 17.3039 18.6979 17.2124C18.6586 17.1209 18.6014 17.0382 18.5297 16.9691L17.4697 18.0301ZM13.6787 14.2471L17.4697 18.0301L18.5297 16.9691L14.7377 13.1851L13.6787 14.2471Z'
				fill='currentColor'
			/>
		</g>
		<defs>
			<clipPath id='clip0_3085_11767'>
				<rect width='22' height='22' fill='currentColor' transform='translate(0.5)' />
			</clipPath>
		</defs>
	</svg>
);
